import React from 'react'
import { EnumDictionary } from '../lib/utils/enumDictionary'
import Link from 'next/link'
import { classNames } from '../lib/utils/classNames'
import { UrlObject } from 'node:url'

export enum buttonHierarchy {
  primary,
  secondary,
  tertiary,
  custom,
}
const buttonStyleDictionary: EnumDictionary<buttonHierarchy, string> = {
  [buttonHierarchy.primary]:
    'block text-neutralWhite font-medium border bg-brandLightBlue border-brandLightBlue/90 hover:bg-brandDarkBlue/80 hover:border-brandDarkBlue/10 disabled:border-neutralGray',
  [buttonHierarchy.secondary]:
    'block bg-neutralWhite text-brandDarkPurple border border-brandDarkPurple',
  [buttonHierarchy.tertiary]:
    'tertiary border border-gray-400/80 text-black bg-white/5 backdrop-blur-md',
  [buttonHierarchy.custom]: '',
}

export enum buttonShape {
  rectangle,
  pill,
  custom,
}
const buttonShapeDictionary: EnumDictionary<buttonShape, string> = {
  [buttonShape.rectangle]: 'rounded-lg',
  [buttonShape.pill]: 'rounded-[20em]',
  [buttonShape.custom]: '',
}

interface ButtonProps {
  link?: string | UrlObject
  rel?: string
  target?: string
  onClick?: (e: any) => void
  type?: 'button' | 'submit' | 'reset' | undefined
  hierarchy: buttonHierarchy
  shape: buttonShape
  className?: string
  children?: any
  disabled?: boolean
  loading?: boolean
}

const LinkButton = ({
  link,
  rel,
  target,
  onClick,
  hierarchy,
  children,
  shape,
  className,
  type,
  disabled = false,
  loading = false,
}: ButtonProps) => {
  const isDisabled = disabled || loading

  const spinner = (
    <span className="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
  )

  return (
    <>
      {link ? (
        <Link
          href={link}
          rel={rel}
          target={target}
          className={classNames(
            buttonStyleDictionary[hierarchy],
            buttonShapeDictionary[shape],
            className ? className : '',
            'flex items-center justify-center',
            isDisabled ? 'pointer-events-none opacity-70' : '',
          )}
        >
          {loading ? spinner : children}
        </Link>
      ) : (
        <button
          onClick={onClick}
          type={type || undefined}
          className={classNames(
            buttonStyleDictionary[hierarchy],
            buttonShapeDictionary[shape],
            isDisabled ? 'disabled-button pointer-events-none opacity-70' : '',
            className ? className : '',
            'flex items-center justify-center',
          )}
          disabled={isDisabled}
        >
          {loading ? spinner : children}
        </button>
      )}
    </>
  )
}

export default LinkButton
